var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.passiveWrapperClasses},[_c('div'),_c('img',{attrs:{"loading":"lazy","src":this.iconUrl,"alt":" "},on:{"error":_vm.handleMissingImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }